<script>
export default {
    name: 'CoiPolicyLink',

}
</script>
<template>
  <a
    href="https://www.clinicalgenome.org/docs/clingen-expert-panel-conflict-of-interest-policy/"
    target="coi-policy"
  >
    <slot>Expert Panel Conflict of Interest Policy</slot>
  </a>
</template>